import { t } from '@framework/i18n';
import { uiTheme, uiThemeComponentTokens, uiThemeTokens } from '@framework/ui';
import { OverrideToken } from 'antd/es/theme/interface';
import { AliasToken } from 'antd/es/theme/internal';
import { merge } from 'lodash';

export const theme = {
  ...uiTheme,
  contentMaxWidth: 1248,

  // Header
  layoutHeaderHeight: 64,
  layoutHeaderContentHeight: 64,
  whiteLanguageMenuColor: true,

  // Applicativi
  logoUrl: require('./images/MiC_logo_esteso_BLU.svg'),
  logoUrlDark: require('./images/MiC_logo_esteso_Negativo.svg'),
  logoAltText: t('mic.front-footer-logo.alt', 'Logo Ministero della Cultura'),
  logoFrontName: t('logo.front-name.servizi-online', 'Servizi'),
  logoTextLine1: '',
  logoTextLine2: '',
  spaceImageUrl: require('./images/space.png'),

  bluItalia: '#0066cc',
  moduleDelegateColor: '#177add',

  viewPdfLabel: 'Apri',
  enablePdfDrawer: true,
  openModulePdfInNewWindow: true,
  showProtocolNumberAsSubmissionNumberColumn: true,
  showPhaseSubmissionColumn: true,
  showAreaInquiryFilter: true,
  showAlternateSummaryIcon: true,
  showSummarySectionBadge: false,

  isOfficePecRequired: false,

  redirectToFirstModule: true,
  hideProcedureDocumentsTab: true,

  showOfficeCodeDropdown: true,
};

// È importante utilizzare `merge` perché tutti i token dell'ui
// sono _annidati_ (come li definisce Ant.Design), quindi per fare
// sovrascritture parziali dobbiamo usare merge e non un semplice
// spread
export const themeComponentTokens = merge(uiThemeComponentTokens, {
  Layout: {},
  Button: {},
  Breadcrumb: {},
  Menu: {
    motionDurationMid: '0.05',
    motionDurationSlow: '0.1',
    activeBarHeight: 0,
    linkDecoration: 'none',
  },
} satisfies Partial<OverrideToken>);

export const themeTokens = merge(uiThemeTokens, {
  fontFamily:
    "'Titillium Web', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",

  colorPrimary: '#0066cc',
  colorPrimaryHover: '#0053a6',

  colorSuccess: '#008554',
  colorInfo: '#0b00d9',
  colorWarning: '#D68100', // '#ff9700',
  colorError: '#cb1d15',

  colorLink: '#0066cc',
  colorLinkActive: '#0053a6',
  colorLinkHover: '#0053a6',

  colorSuccessBg: '#f6ffed',
  colorSuccessBgHover: '#d9f7be',
  colorSuccessBorder: '#b7eb8f',
  colorSuccessBorderHover: '#95de64',
} satisfies Partial<AliasToken>);
